module.exports = __webpack_public_path__ + "img/4.9e2e77eb.jpg";